(function () {
  // SETTINGS
  const AUTOPLAY_MS = 3000;
  const TRACK_ID = 'Slider-template--25563033534797__featured_collection';
  const MQ = window.matchMedia('(max-width: 989px)'); // Dawn desktop breakpoint

  let cleanup = null; // teardown function holder

  function setup() {
    const track = document.getElementById(TRACK_ID);
    if (!track) return;

    const sc = track.closest('slider-component');
    if (!sc) return;

    // avoid double init
    if (track.dataset.pgLoopInit === '1') return;
    track.dataset.pgLoopInit = '1';

    const nextBtn = sc.querySelector('.slider-button--next');
    const prevBtn = sc.querySelector('.slider-button--prev');
    const counter = sc.querySelector('.slider-counter');
    const sliderEl = sc.querySelector('.slider'); // scrollable container

    // --- ENABLE SWIPE ON MOBILE ---
    if (sliderEl) {
      sliderEl.style.overflowX = 'auto';
      sliderEl.style.webkitOverflowScrolling = 'touch';
      // Use snap for nice manual swiping; we'll toggle it off during scripted moves
      sliderEl.style.scrollSnapType = 'x mandatory';
    }
    // Make each slide snap to start (helps manual swipe)
    track.querySelectorAll('.grid__item, .slider__slide').forEach((li) => {
      li.style.scrollSnapAlign = 'start';
    });

    // built-in counter can glitch with recycling; hide on mobile
    if (counter) counter.style.display = 'none';

    // helper: one card width + gap
    const stepPx = () => {
      const first = track.querySelector('.grid__item, .slider__slide');
      if (!first) return 0;
      const rect = first.getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(track).columnGap || 0);
      return rect.width + (isNaN(gap) ? 0 : gap);
    };

    // helper: toggle snapping while we animate (prevents tug/jump)
    const setSnap = (on) => {
      if (!sliderEl) return;
      sliderEl.style.scrollSnapType = on ? 'x mandatory' : 'none';
    };

    // Programmatic move by one card, then recycle edge slide without jolt
    const smoothThenRecycle = (dir) => {
      const step = stepPx();
      if (!step) return;

      setSnap(false); // disable snap during scripted scroll
      const targetLeft = track.scrollLeft + dir * step;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });

      const start = performance.now();
      const check = () => {
        const near =
          (dir > 0 && track.scrollLeft >= targetLeft - 2) ||
          (dir < 0 && track.scrollLeft <= targetLeft + 2);

        if (near || performance.now() - start > 600) {
          const old = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';

          if (dir > 0) {
            const first = track.firstElementChild;
            if (first) {
              track.appendChild(first);
              track.scrollLeft -= step;
            }
          } else {
            const last = track.lastElementChild;
            if (last) {
              track.prepend(last);
              track.scrollLeft += step;
            }
          }

          track.style.scrollBehavior = old || '';
          setSnap(true); // re-enable snap for manual swiping
        } else {
          requestAnimationFrame(check);
        }
      };
      requestAnimationFrame(check);
    };

    const onNext = (e) => { e?.preventDefault(); e?.stopPropagation(); pauseAutoplay(); smoothThenRecycle(1); resumeAutoplaySoon(); };
    const onPrev = (e) => { e?.preventDefault(); e?.stopPropagation(); pauseAutoplay(); smoothThenRecycle(-1); resumeAutoplaySoon(); };

    nextBtn?.addEventListener('click', onNext, true);
    prevBtn?.addEventListener('click', onPrev, true);

    // --- AUTOPLAY (mobile only) with pause on user interaction ---
    let timer = null;
    const startAutoplay = () => { if (!timer) timer = setInterval(() => smoothThenRecycle(1), AUTOPLAY_MS); };
    const stopAutoplay  = () => { if (timer) { clearInterval(timer); timer = null; } };
    const pauseAutoplay = stopAutoplay;
    let resumeTO = null;
    const resumeAutoplaySoon = () => {
      clearTimeout(resumeTO);
      resumeTO = setTimeout(startAutoplay, AUTOPLAY_MS * 1.5);
    };

    // Pause while user touches/drags; resume after idle
    const userStart = () => { pauseAutoplay(); };
    const userEnd   = () => { resumeAutoplaySoon(); };
    sliderEl?.addEventListener('touchstart', userStart, { passive: true });
    sliderEl?.addEventListener('pointerdown', userStart, { passive: true });
    sliderEl?.addEventListener('touchend', userEnd, { passive: true });
    sliderEl?.addEventListener('pointerup', userEnd, { passive: true });
    sliderEl?.addEventListener('scroll', () => { // scrolling = user or script; just debounce resume
      pauseAutoplay();
      resumeAutoplaySoon();
    }, { passive: true });

    startAutoplay(); // kick off autoplay on mobile

    // --- TEARDOWN when leaving mobile ---
    cleanup = () => {
      stopAutoplay();
      clearTimeout(resumeTO);
      nextBtn?.removeEventListener('click', onNext, true);
      prevBtn?.removeEventListener('click', onPrev, true);
      sliderEl?.removeEventListener('touchstart', userStart);
      sliderEl?.removeEventListener('pointerdown', userStart);
      sliderEl?.removeEventListener('touchend', userEnd);
      sliderEl?.removeEventListener('pointerup', userEnd);
      track.dataset.pgLoopInit = '';
      // leave snap enabled for normal behavior if desktop reuses markup
      if (counter) counter.style.display = '';
    };
  }

  function maybeInit() {
    if (MQ.matches) {
      setup();     // only run on mobile
    } else if (cleanup) {
      cleanup();   // ensure it’s off on desktop
    }
  }

  // Initial run + on breakpoint change
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeInit);
  } else {
    maybeInit();
  }
  MQ.addEventListener ? MQ.addEventListener('change', maybeInit) : MQ.addListener(maybeInit);

  // Re-init when editing in the customizer
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target?.contains(document.getElementById(TRACK_ID))) maybeInit();
  });
})();
